import React from 'react'
import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import ProductTicketService from '../../../../services/ProductTicketService';
import ListSupportTicket from './ListSupportTicket';
import SupportTicketForm from './SupportTicketForm';

const SupportTickets = ({ customerId, priorityOptions, statusOptions, productOptions, reset, listType, setListType }) => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [view, setView] = useState('list');
    const [showStatusPriorityModal, setShowStatusPriorityModal] = useState(false);
    const [showAssignModal, setShowAssignModal] = useState(false);
    const onTicketSubmit = async(data) => {
        try {
            data.customer_id = customerId;
            const response = await ProductTicketService.create({data});
            if (response.status === 201) {
                toast.success(response?.data?.data?.message);
                setView('list');
                setListType('list');
                setRows(prevRows => [...prevRows, response?.data?.data]);
                reset();
            }
        } catch (error) {
            toast.error(error?.message || "An error occurred");
        }
    };

    useEffect(() => {
        const fetchSupportTickets = async () => {
            if (!customerId) {
                console.error('Customer ID is missing');
                return;
            }
            setLoading(true);
            try {
                const response = await ProductTicketService.getByCustomer(customerId);
                if (response.status === 200) {
                    setRows(response?.data?.data || []);
                    setView(response?.data?.data?.length > 0 ? 'list' : 'form');
                }
            } catch (error) {
                toast.error(error?.message || "An error occurred while fetching support tickets");
            } finally {
                setLoading(false);
            }
        };

        fetchSupportTickets();
    }, [customerId]);

    const submitAssign = async (id, data) => {
        try {
            const response = await ProductTicketService.assign(id, { data });
            if (response.status === 200) {
                const responseData = response?.data?.data;
                toast.success(response?.data?.message);
                setRows(prevRows =>
                    prevRows.map(row => {
                        if (row.id === id) {
                            return {
                                ...row,
                                assigned_to: responseData.assigned_to,
                                assignedTo: { name: responseData.assignedTo?.name },
                            };
                        }
                        return row;
                    })
                );
                setView('list');
                reset();
                closeAllModals();

            }
        } catch (error) {
            toast.error(error?.message || "An error occurred");
        }
    };

    const changeStatusOrPriority = async (id, data, columnType) => {
        try {
            const response = await ProductTicketService.changeStatusOrPriority(id, { data }, columnType);
            if (response.status === 200) {
                toast.success(response?.data?.message);
                setRows(prevRows => prevRows.map(row => row.id === id ? { ...row, [columnType]: data[columnType] } : row));
                setView('list');
                reset();
                closeAllModals();
            }
        } catch (error) {
            console.log("Error in changing support status or priority.", [error]);
            toast.error(error?.message || "An error occurred");
        }
    };
    
    const closeAllModals = () => {
        setShowStatusPriorityModal(false);
        setShowAssignModal(false);
    };

    if (loading) {
        return (
            <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    return (view === 'form' || listType === 'form') ? (
        <SupportTicketForm
            customerId={customerId}
            priorityOptions={priorityOptions}
            statusOptions={statusOptions}
            onTicketSubmit={onTicketSubmit}
            productOptions={productOptions}
            setListType={setListType}
        />
    ) : (
        <ListSupportTicket
            rows={rows}
            customerId={customerId}
            loading={loading}
            priorityOptions={priorityOptions}
            statusOptions={statusOptions}
            submitAssign={submitAssign}
            setShowStatusPriorityModal={setShowStatusPriorityModal}
            setShowAssignModal={setShowAssignModal}
            showStatusPriorityModal={showStatusPriorityModal}
            showAssignModal={showAssignModal}
            changeStatusOrPriority={changeStatusOrPriority}
        />
    );
}

export default SupportTickets
